/* istanbul ignore file */
import { array as codecArray, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AssignmentExportColumn } from './AssignmentExportColumn';
const ExportAssignmentCSVDataParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('info')],
    ['columns', /* #__PURE__ */ codecArray(AssignmentExportColumn)],
    [
        'userIds',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ codecArray(codecNumber)),
        'user_ids',
    ],
]);
export class ExportAssignmentCSVData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ExportAssignmentCSVDataParser.decode(input).map(res => new ExportAssignmentCSVData(res));
    }
    static unsafeDecode(input) {
        return ExportAssignmentCSVData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExportAssignmentCSVDataParser.encode(data);
    }
    static schema() {
        return ExportAssignmentCSVDataParser.schema();
    }
}
